import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixins from './mixins'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios);

//Fontawesome
import {library} from '@fortawesome/fontawesome-svg-core'
import {fad} from '@fortawesome/pro-duotone-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

Vue.component('icon', FontAwesomeIcon);
library.add(fab, fad);

import 'bootstrap'

//Socialshare
import SocialSharing from 'vue-social-sharing';

Vue.component('SocialSharing', SocialSharing);
require('vue-social-sharing/dist/vue-social-sharing.min');

//Poster Scroll
import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo);

//PDF
import vuepdf from 'vue-pdf';

Vue.component('pdf', vuepdf);


//Video
import vPlayBack from 'v-playback';

Vue.use(vPlayBack);

//Youtube
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)

import Print from 'vue-print-nb'

Vue.use(Print);

//Jquery
window.$ = window.jQuery = require('jquery');


import VueLazyload from 'vue-lazyload'
const errorimage = require('./assets/img/error-img.png')

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: errorimage,
  attempt: 2,
  observer: true,
  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  }
});

//Vue-Analytics (GOOGLE ANALYTICS)
import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
  id: 'UA-109856828-10',
  autoTracking: {
    screenview: true
  },
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
});

import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

//Browserdetect
import browserDetect from "vue-browser-detect-plugin";

Vue.use(browserDetect);
Vue.use(require('vue-moment'));

import VueNoty from 'vuejs-noty'

Vue.use(VueNoty, {
  timeout: 4000,
  theme: 'bootstrap-v4',
  progressBar: true,
  layout: 'topRight'
});

Vue.config.productionTip = false

new Vue({
  mixins: [mixins],
  router,
  store,
  render: h => h(App)
}).$mount('#app')
